import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.viewUrl;

const viewUrlData = createSelector([selector], (state) => state);

export default {
  viewUrlData
};
